import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router';
import DiscountedPrice from 'swag-client-common/components/ui/discounted-price';
import { FREE } from 'swag-client-common/constants';
import { PromocodeMeasurementEnum } from 'swag-common/constants/promocode';
import { Price } from 'swag-client-common/utils/price';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { YouWillMake } from 'swag-client-common/components/partials/you-will-make';
import SampleAndRegularProductsPopup from '../../../../../popups/sample-and-regular-products-popup';
import { SuperSpeedWarningPopup } from '../../../../../popups/super-speed-warning-popup';
import { CheckoutPrintLocationRemovedPopup } from '../../../../../popups/checkout-print-location-warnings-popup';
import BuildABoxCartButton from '../build-a-box-cart-button';
import classes from './checkout-block.scss';
import { totalTitle } from './checkout-block.utils';
import { ProceedButton } from './components/proceed-button';
import { canContinueShopping } from './checkout-block.utils';
export default function CheckoutBlock(props) {
  const {
    total,
    totalBeforeDiscount,
    promocodeDiscount,
    measurement,
    itemsCount,
    sampleDeductionDiscount,
    sampleDeductionDiscountLabel,
    absoluteDiscountValue,
    isSuperSpeedCheckoutWarn,
    onCheckoutStart,
    className,
    discountName,
    setupFeeDiscount,
    isDiscountedPriceShown,
    isConflictInBox,
    isOutOfStockConflicts,
    showCheckoutOutOfStockAdjustmentPopup,
    showCheckoutPrintLocationWarningsPopup,
    cartBoxesSpecialProductsNotPresentConflict,
    showCartBoxesSpecialProductsWarningPopup,
    showCheckoutLEQtyAdjustmentPopup,
    showSuperSpeedWarningPopup,
    showItemsConflictPopup,
    isConflictInStandaloneItemsByMinQuant,
    isConflictInStandaloneItemsByMaxQuant,
    containsDestinationConflictItems,
    includeHiddenItems,
    includeSuperSpeedItems,
    isLEError,
    showSampleAndRegularProductsPopup,
    validateSuperSpeedItems,
    isItemPrintLocationConflicts,
    isCartItemsLogoEmpty,
    isAdminMode,
    isSwagAdminMode,
    handleSwagAdminModeCheckout,
    isResellerBuildCartMode,
    resellersCommission,
    productsCommission,
    isPromocodeDiscountPresent
  } = props;
  const onCheckoutClick = () => {
    if (isSwagAdminMode) {
      return handleSwagAdminModeCheckout();
    }
    if (isSuperSpeedCheckoutWarn) {
      return showSuperSpeedWarningPopup();
    }
    if (isLEError) {
      return showCheckoutLEQtyAdjustmentPopup();
    }
    if (isOutOfStockConflicts || includeHiddenItems) {
      return showCheckoutOutOfStockAdjustmentPopup();
    }
    if (isItemPrintLocationConflicts || isCartItemsLogoEmpty) {
      return showCheckoutPrintLocationWarningsPopup();
    }
    if (isConflictInStandaloneItemsByMinQuant || isConflictInStandaloneItemsByMaxQuant || isConflictInBox) {
      return showItemsConflictPopup();
    }
    if (cartBoxesSpecialProductsNotPresentConflict) {
      return showCartBoxesSpecialProductsWarningPopup();
    }
    if (includeSuperSpeedItems) {
      return validateSuperSpeedItems();
    }
    onCheckoutStart();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: classes.title
  }, "Order Summary"), /*#__PURE__*/React.createElement(BuildABoxCartButton, {
    className: classes.buildABoxButton,
    disabled: false
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.checkoutBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.dataBlock
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.greyInfo, classes.left)
  }, "Number of Items:"), /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.greyInfo, classes.right),
    "data-span": "Number"
  }, itemsCount)), !!sampleDeductionDiscount && /*#__PURE__*/React.createElement("div", {
    className: classes.dataBlock
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.secondary
  }, sampleDeductionDiscountLabel), /*#__PURE__*/React.createElement("h5", {
    className: classes.secondaryPrice,
    "data-text": "SampleDiscount"
  }, "-", Price.formatPrice(sampleDeductionDiscount))), !!promocodeDiscount && /*#__PURE__*/React.createElement("div", {
    className: classes.dataBlock
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.secondary
  }, "Discount (", discountName || 'promocode', ' ', measurement === PromocodeMeasurementEnum.ABSOLUTE ? `${Price.formatPrice(promocodeDiscount)}` : `${promocodeDiscount} %`, ' ', "off):"), /*#__PURE__*/React.createElement("h5", {
    className: classes.secondaryPrice,
    "data-text": "PromocodeValue"
  }, "-", `${Price.formatPrice(absoluteDiscountValue)}`)), !!setupFeeDiscount && /*#__PURE__*/React.createElement("div", {
    className: classes.dataBlock
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.secondary
  }, "Free setup fee: "), /*#__PURE__*/React.createElement("h5", {
    className: classes.secondaryPrice,
    "data-text": "SetupFeeDiscount"
  }, setupFeeDiscount ? `-${Price.formatPrice(setupFeeDiscount)}` : '')), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.dataBlock, classes.hr)
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.dataBlock, classes.totalPriceBlock)
  }, /*#__PURE__*/React.createElement("h5", {
    className: classes.totalPriceTitle
  }, totalTitle), /*#__PURE__*/React.createElement("h5", {
    className: classes.totalPrice,
    "data-text": "SummaryTotal"
  }, isDiscountedPriceShown && /*#__PURE__*/React.createElement(DiscountedPrice, {
    price: total,
    totalBeforeDiscount: totalBeforeDiscount
    // @ts-ignore
    ,
    discount: promocodeDiscount
  }) || /*#__PURE__*/React.createElement("span", null, Number.isFinite(total) && total !== 0 ? Price.formatPrice(total) : FREE))), canContinueShopping && /*#__PURE__*/React.createElement("div", {
    className: classes.continueShoppingWrapper,
    "data-button": "Shop Products"
  }, /*#__PURE__*/React.createElement(Link, {
    to: APP_ROUTES.ALL_SWAG,
    className: classes.continueShopping
  }, isAdminMode ? 'Add products' : 'Continue Shopping'))), /*#__PURE__*/React.createElement(ProceedButton, {
    onCheckoutClick: onCheckoutClick,
    containsDestinationConflictItems: containsDestinationConflictItems,
    showSampleAndRegularProductsPopup: showSampleAndRegularProductsPopup
  }), /*#__PURE__*/React.createElement(YouWillMake, {
    className: classes.youWillMakeClass,
    isResellerAdminMode: isResellerBuildCartMode,
    resellersCommission: resellersCommission,
    productsCommission: productsCommission,
    isPromocodeDiscountPresent: isPromocodeDiscountPresent
  }), /*#__PURE__*/React.createElement(SampleAndRegularProductsPopup, null), /*#__PURE__*/React.createElement(SuperSpeedWarningPopup, null), /*#__PURE__*/React.createElement(CheckoutPrintLocationRemovedPopup, null));
}